// extracted by mini-css-extract-plugin
module.exports = {"title":"TipsForm_title__gPA0r","controls":"TipsForm_controls__ysn7N","button":"TipsForm_button__VBLcQ"};